// Vuex
import consts from "@/consts.js";
import Request from './request';
import store from '@/store.js';
import request_configs from "./request_configs";

async function fetch(data) {
  if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
  return Request('get', "api/announcements/index", data);
}

async function readAllAnnouncement(data) {
  return Request(
     'post',
     'api/announcements/update-read',
      data,
      false,
      false,
      false,
  )
}

async function readAnnouncement(data) {
  return Request(
     'post',
     'api/announcements/readAnnouncement',
      data,
      false,
      false,
      false,
  )
}

async function getUnreadAnnouncementsCount(data) {
  request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
  const response = await Request(
      'post',
     'api/top/order-waiting-process',
      data,
      false,
      false,
    false,
    request_configs.Headers
  )
  if (response.data && response.data.status.isOK()) {
      store.commit("unReadNotice", response.data.supplier_announcement.unread_count );
  }
  return response;
}

export default {
  fetch,
  readAllAnnouncement,
  readAnnouncement,
  getUnreadAnnouncementsCount,
};